import type { ReactNode } from 'react';

export const symbol_backspace: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m560-438 91 91q9 9 21 9t21-9q9-9 9-21.5t-9-21.5l-91-90 90-90q9-9 9-21t-9-21q-9-9-21.5-9t-21.5 9l-89 90-91-91q-9-9-21-9t-21 9q-9 9-9 21.5t9 21.5l91 90-91 90q-9 9-9 21t9 21q9 9 21.5 9t21.5-9l90-90ZM350-160q-14.25 0-27-6.38-12.75-6.37-21-17.62L107-444q-12-15.68-12-35.84Q95-500 107-516l194-260q8.25-11.25 21-17.63 12.75-6.37 27-6.37h472q24.75 0 42.38 17.62Q881-764.75 881-740v520q0 24.75-17.62 42.37Q845.75-160 821-160H350Zm0-60h471v-520H350L155-480l195 260Zm138-260Z"
		/>
	</svg>
);
